export const assetsBaseUrl = 'https://my-beauty-pa-poc-looks-assets.s3.ap-southeast-2.amazonaws.com'
